import { render, staticRenderFns } from "./pointTaskDetail.vue?vue&type=template&id=fbd9a014&scoped=true"
import script from "./pointTaskDetail.vue?vue&type=script&lang=js"
export * from "./pointTaskDetail.vue?vue&type=script&lang=js"
import style0 from "./pointTaskDetail.vue?vue&type=style&index=0&id=fbd9a014&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd9a014",
  null
  
)

export default component.exports